import { createRouter, createWebHashHistory } from 'vue-router'
import EventList from '../views/EventList.vue'
import AboutView from '@/views/AboutView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: EventList,
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView,
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

export default router
